import { useState } from 'react'

export type RouteFocus = 'focus' | 'dim' | 'calm'

/**
 * Classe une route pour le rendu baseline-calme / focus.
 *  - rien de sélectionné ni survolé → `'calm'` (fine, sans animation)
 *  - cette route est celle survolée OU sa destination est l'île sélectionnée → `'focus'`
 *  - sinon, quand quelque chose est focus → `'dim'` (estompée)
 *
 * NB : l'appelant (RouteLayer) ne transmet `selectedIslandId` que si une route y
 * mène réellement, sinon sélectionner une île sans mission estomperait tout.
 */
export function classifyRoute(
  routeKey: string,
  /**
   * Île visée, ou `null` quand la destination n'en est pas une (chasse
   * légendaire). Une route sans île ne peut pas être mise au premier plan par la
   * sélection d'une île : elle ne se focalise qu'au survol de son propre tracé.
   */
  destinationIslandId: number | null,
  selectedIslandId: number | null,
  hoveredKey: string | null,
): RouteFocus {
  const anyFocus = hoveredKey !== null || selectedIslandId !== null
  if (!anyFocus) return 'calm'
  const isThis =
    routeKey === hoveredKey || (destinationIslandId !== null && destinationIslandId === selectedIslandId)
  return isThis ? 'focus' : 'dim'
}

/** État minimal de focus carte : la flotte/route actuellement survolée (desktop). */
export function useMapFocus() {
  const [hoveredKey, setHoveredKey] = useState<string | null>(null)
  return { hoveredKey, setHoveredKey }
}
